import { Box, Typography, Button } from "@mui/material";
import Link from "@/components/atoms/Link/link.atom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { NotFoundRouteProps } from "@tanstack/react-router";

/**
 * NotFound
 * Displays a styled 404 Not Found page with a call-to-action button.
 */
export function NotFound(props: NotFoundRouteProps) {
    // const { data } = props;

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                bgcolor: "background.default",
                px: 2,
                mt: { xs: 12, sm: 18, md: 24 },
            }}
        >
            <Box
                sx={{
                    textAlign: "center",
                    maxWidth: 400,
                    p: 4,
                    borderRadius: 3,
                    boxShadow: 3,
                    bgcolor: "background.paper",
                    border: theme => `1px solid ${theme.palette.divider}`,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <ErrorOutlineIcon color="primary" sx={{ fontSize: 64, mb: 2 }} />
                <Typography variant="h1" color="primary" fontWeight={700} gutterBottom>
                    404
                </Typography>
                <Typography variant="h5" fontWeight={500} gutterBottom>
                    Page Not Found
                </Typography>
                <Typography variant="body1" color="text.secondary" mb={3}>
                    Sorry, the page you are looking for does not exist or has been moved.
                </Typography>
                <Button
                    component={Link}
                    to="/"
                    variant="contained"
                    color="primary"
                    size="large"
                    sx={{ mt: 2, borderRadius: 2, fontWeight: 600 }}
                >
                    Go to Home
                </Button>
            </Box>
        </Box>
    );
}

export default NotFound;
